export default "__VITE_ASSET__f146b1bc__"